<template>
  <router-view />
</template>

<script>
export default {
  name: 'TesEmployees'
};
</script>

<style lang="scss" scoped></style>
